import {
    apiRequest,
    schedulerDetail, 
    schedulerUpdate,
} from "../../../../../services/adapters/kepegawaian/schedulerService"

class IndexRepository {
    fetchDetail = async (query) => {
        return await apiRequest("get", schedulerDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", schedulerUpdate, {
            body: query
        }, true)
    }

}

export default IndexRepository